import * as React from 'react';
import { StatelessComponent, HTMLProps } from 'react';
import { NavProvider } from './NavProvider';
import { LocationDescriptorObject } from 'history';
import { Match, ValOrFunc } from './utils';
import styled from 'styled-components';

export type LinkProps = HTMLProps<HTMLAnchorElement> & {
  to: ValOrFunc<(string | LocationDescriptorObject)>;
  activeClassName?: string;
  match?: ValOrFunc<Match>;
  replace?: boolean;
  noSubscribe?: boolean;
};

const StyledA = styled.a``;

export const Link: StatelessComponent<LinkProps> = (props: LinkProps) => {
  const { to, match, noSubscribe, replace, activeClassName = '', className, ref, ...aProps } = props;
  return (
    <NavProvider
      {...{ to, match, noSubscribe, replace }}
      renderChild={(params) => (
        <StyledA
          {...aProps}
          href={params.href}
          className={[(params.match !== false ? activeClassName : ''), className].join(' ')}
          onClick={(e) => {
            if (aProps.onClick) {
              aProps.onClick(e);
            }
            return params.handleAnchorClick(e);
          }}
        />
      )}
    />
  );
};


// WEBPACK FOOTER //
// src/app/src/components/Link/Link.tsx